/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-29 12:35:59                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-21 11:44:34                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * ProfileMenu: Profile menu
    * useEffect: get profile informations
*/

/* Imports */
import { createElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "../../../../i18n";
import {
  PowerIcon, 
  UserCircleIcon 
} from "@heroicons/react/24/solid";
import {
  Button, 
  Menu, 
  MenuHandler, 
  MenuItem, 
  MenuList, 
  Typography 
} from "@material-tailwind/react";
import { useKeycloak } from "@react-keycloak/web";
/***/

/* Components */
import Avatar from "../../../avatar/Avatar";
/***/

/**
* ProfileMenu: Profile menu
* Contain the connected user account button and disconnect button
*/
export function ProfileMenu({
  className
}: {
  className?: string
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const closeMenu = () => setIsMenuOpen(false);
  const { keycloak } = useKeycloak();
  const [profile, setProfile] = useState<any>();

  const profileMenuItems = [{
    label: t("myProfile"),
    icon: UserCircleIcon,
    action: () => { navigate(`/users/${profile.sub}`); }
  }, {
    label: t("signOut"),
    icon: PowerIcon,
    action: async() => {
      localStorage.clear();
      await keycloak.logout();
    }
  }];

  /**
  * useEffect: get profile informations 
  */
  useEffect(() => {
    keycloak.loadUserInfo().then((ret) => setProfile(ret));
  }, [keycloak]);
  /***/

  return (
    <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end">
      <MenuHandler className={"p-0 "+className}>
        <Button variant="text">
          <Avatar name={profile ? profile.name : ""} />
        </Button>
      </MenuHandler>
      
      <MenuList className="p-1">
        {profileMenuItems.map(({ label, icon, action }, key) => {
          const isLastItem = key === profileMenuItems.length - 1;

          return (
            <MenuItem key={label}
                      onClick={() => {action(); closeMenu();}}
                      className={`flex items-center gap-2 rounded ${
                        isLastItem
                          ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
                          : ""
                      }`}> 
              {createElement(icon, {
                className: `h-4 w-4 ${isLastItem ? "text-red-500" : ""}`,
                strokeWidth: 2,
              })}

              <Typography as="span"
                          variant="small"
                          className="font-normal"
                          color={isLastItem ? "red" : "inherit"}>
                {label}
              </Typography>
            </MenuItem>
          );
        })}
      </MenuList>
    </Menu>
  );
}
/***/
